import React from 'react';
import { Components } from './styled';
import { EventProps } from 'react-big-calendar';

const CalendarDefaultEvent: React.FC<EventProps> = (event) => {
  const {
    event: { data, type },
  } = event as EventProps<any>;
  const { title, subtitle } = { title: 'hau', subtitle: 'bau' };

  return (
    <Components.Event>
      <Components.EventHeader displayFlex alignItems='flex-start'>
        {/*{IconComponent && <Components.EventIconWrapper></Components.EventIconWrapper>}*/}
        {subtitle ? (
          <Components.EventSubtitle>{subtitle}</Components.EventSubtitle>
        ) : (
          title && <Components.EventTitle>{title}</Components.EventTitle>
        )}
      </Components.EventHeader>
    </Components.Event>
  );
};

export default CalendarDefaultEvent;
